import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const fetchActiveBanner = async (bannerId: number) => {
	const url = `/homepage/admin/fullscreentakeover/${bannerId}/`;

	const response = await cmsClient.get<CarouselBanner>(url);

	return response.data;
};

interface Options {
	onSuccess?: (banners: CarouselBanner) => void;
}

const useActiveFullScreenTakeover = (
	bannerId: number,
	options: Options = {}
) => {
	const query = useQuery(
		["full-screen-takeover-active-banner", bannerId],
		() => fetchActiveBanner(bannerId),
		{
			...options,
		}
	);

	return query;
};

export default useActiveFullScreenTakeover;
